<!-- <mat-dialog-actions class="flex justify-end">
  <button mat-button mat-dialog-close>
    <span class="material-symbols-outlined font-semibold text-black">
        close
    </span>
  </button>
</mat-dialog-actions> -->

<mat-dialog-content>
    <div class="flex items-center w-full">
        <div class="w-50">
            <h6 mat-dialog-title class="m-0 text-sky-600" style="font-size: 17px;">Trainer Details</h6>
        </div>
        <button mat-button mat-dialog-close class="w-50 flex items-center justify-end">
            <span class="material-symbols-outlined font-semibold text-black">
                close
            </span>
        </button>
    </div>


    <table class="table-auto budget-table mt-2">
        <tr>

            <th class="w-50">Trainer Name</th>
            <th class="text-center">Training Name</th>
            <th class="text-center">Role</th>
            <th class="text-center">Role Code</th>
            <th class="text-center">Oragnization</th>
            <th class="text-center">Sangha Member</th>
            <th class="text-center">Base Location</th>
        </tr>
        <tbody>
            @if(trainerHistory().length === 0) {
            <tr>
                <td colspan="8" class="text-center">No history found for the selected trainer and date range.</td>
            </tr>
            }@else {
            @for (history of trainerHistory(); track i; let i = $index) {
            <tr>
                <td class="text-center">{{ history.trainerName }}</td>
                <td class="text-center">{{ history.trainingName }}</td>
                <td class="text-center">{{ history.roleName }}</td>
                <td class="text-center">{{ history.roleCode }}</td>
                <td class="text-center">{{ history.orgUnitName }}</td>
                <td class="text-center">{{ history.isShgMember ? 'Yes' : 'No' }}</td>
                <td class="text-center">{{ history.isBaseLocation ? 'Yes' : 'No' }}</td>
            </tr>

            }
            }

        </tbody>
    </table>
</mat-dialog-content>